import { selectPayoutDeath } from 'selectors/dashboard';
import { fetchDeath } from 'actions/digital-advice';
import { createPage } from './AwardRules';
import { DEATH } from '../constants/dashboardTypes';

export default createPage(DEATH, selectPayoutDeath, fetchDeath);
